import React, { useState } from "react";
import api, { setAuthToken } from "../api/api";
import { saveToken } from "../utils/auth";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    try {
      const res = await api.post("/auth/login", { email, password });
      const token = res.data.token;
      saveToken(token);
      setAuthToken(token);
      window.location.href = "/dashboard";
    } catch (err) {
      if (err.response?.status === 400 && err.response.data) {
        setErrors(err.response.data);
      } else if (err.response?.status === 401) {
        setErrors({ general: "Invalid email or password" });
      } else {
        setErrors({ general: "Server error" });
      }
    }
  };

  return (
    <>
      <form className="login-form" onSubmit={handleSubmit}>
        <h2 className="title">Login</h2>
        <div className="login-form-conteiner">
          <div className="inputs">
            <div className="label">Email</div>
            <input
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
            />
            {errors.Email && <p style={{ color: "red" }}>{errors.Email[0]}</p>}
          </div>

          <div className="inputs">
            <div className="label">Password</div>
            <input
              name="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
            />
            {errors.Password && <p style={{ color: "red" }}>{errors.Password[0]}</p>}
          </div>
        </div>
        {errors.general && <div className="errors"><p style={{ color: "red" }}>{errors.general}</p></div>}
        <div className="submit-btn">
          <button type="submit">Login</button>
        </div>
        <div style={{ marginTop: "10px" }}>
          <a href="/forgot-password" style={{ textDecoration: "none", color: "#bd8504ff" }}>
            Forgot your password?
          </a>
        </div>
      </form>
    </>
  );
}
